import { render, staticRenderFns } from "./ActionNoticeApproveDocument.vue?vue&type=template&id=95f1246e&"
import script from "./ActionNoticeApproveDocument.vue?vue&type=script&lang=js&"
export * from "./ActionNoticeApproveDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports